import {Box, Button} from "@mui/material";
import React from "react";

interface ActiveAndClosedButtonProps {
    handleActiveTickets: (status: "active" | "closed") => void;
    activeTickets: string;
}

const ActiveAndClosedButton: React.FC<ActiveAndClosedButtonProps> = ({
                                                                         handleActiveTickets,
                                                                         activeTickets
                                                                     }) => {
    return (
        <Box className="flex mb-4 w-full md:w-fit bg-zinc-200 rounded ">
            <Button
                name="active"
                className={
                    activeTickets === "active"
                        ? "!bg-white !text-[#000] !shadow"
                        : "!bg-zinc-200 !text-[#000]"
                }
                sx={{
                    textTransform: "none",
                    padding: {xs: "10px 0px", sm: "10px 60px"},
                    fontSize: "13px",
                    fontWeight:activeTickets === "active"? 500:400,
                    color:activeTickets === "active"?"#454545 !important":"#8C8C8C !important",
                    width: {xs: "50%", sm: "fit-content"},
                }}
                onClick={() => handleActiveTickets("active")}
            >
                Active Tickets
            </Button>
            <Button
                name="closed"
                className={
                    activeTickets === "closed"
                        ? "!bg-white !text-[#000] !shadow"
                        : "!bg-zinc-200 !text-[#000]"
                }
                sx={{
                    textTransform: "none",
                    padding: {xs: "10px 3px", sm: "10px 50px"},
                    fontSize: "13px",
                    fontWeight: activeTickets === "closed"? 500:400,
                    color:activeTickets === "closed"?"#454545 !important":"#8C8C8C !important",
                    width: {xs: "50%", sm: "fit-content"},
                }}
                onClick={() => handleActiveTickets("closed")}
            >
                Closed Tickets (7 Days)
            </Button>
        </Box>
    );
};

export default ActiveAndClosedButton;
